<template>
  <div>
    <section>
      <div class="col-md-12 no-padding">
        <section-header
          :title="$t('message.general')"
          :subtitle="$t('series.jv') + ' ' + jvCode"
        />
        <div class="form-row">
          <div class="col-md-2">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('apps.accounting.label.jv_type') }}</label>
                <BaseDropdown
                  v-model="$v.form.jv_type.$model"
                  :options="journalTypeOptions"
                  :class="[
                    { 'is-invalid': $v.form.jv_type.$error }
                  ]"
                  :disabled="disabled"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('apps.accounting.label.description') }}</label>
                <BaseInput
                  v-if="disabled"
                  :value="replaceCodeToText(form.description, $t)"
                  :disabled="true"
                />
                <BaseInput
                  v-else
                  v-model="form.description"
                  :disabled="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="col-md-12 no-padding">
        <section-header
          :title="$t('apps.accounting.message.journalentrylines')"
        />
        <JournalEntryLine
          :lines.sync="form.lines"
          :isValidated="$v.$dirty"
          :disabled="disabled"
        />
      </div>
    </section>

    <BaseFormAction
      v-if="showActionButtons"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import JournalEntryLine from '../custom/JournalEntryLine.vue'
import { getMasterDataText } from '@/helpers'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  components: {
    JournalEntryLine,
  },

  props: {
    jvCode: String,
    isSubmitted: Boolean,
    disabled: Boolean,
    showActionButtons: Boolean,
    journalEntry: Object,
  },

  data() {
    return {
      form: {
        jv_type: null,
        description: null,
        refs: [],
        lines: [],
      },
    }
  },

  computed: {
    ...mapGetters({
      accountSetting: 'getAccountSetting',
    }),
    journalTypeOptions() {
      const items = this.accountSetting.journal.types
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
      return [
        {
          text: this.$t('placeholder.select'),
          value: null,
        },
        ...items,
      ]
    },
    totalDebit() {
      return this.form.lines.reduce((acc, cur) => acc + Number(cur.debit), 0)
    },
    totalCredit() {
      return this.form.lines.reduce((acc, cur) => acc + Number(cur.credit), 0)
    },
  },

  validations: {
    form: {
      jv_type: {
        required,
      },
      lines: {
        required,
        minLength: minLength(1),
      },
    },
    isValidDebitCredit: {
      isValid: function () {
        const isSelectedSomeAccount = this.form.lines.some((line) => line.account_code)
        const fillAnyNumber =
          this.form.lines.some((line) => Number(line.debit) != 0) ||
          this.form.lines.some((line) => Number(line.credit) != 0)
        return isSelectedSomeAccount && fillAnyNumber && this.totalDebit == this.totalCredit
      },
    },
  },

  watch: {
    form: {
      handler: function () {
        this.$emit('update:form', this.form)
      },
      deep: true,
    },
  },

  methods: {
    handleSubmit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return this.scrollToTop(600)
      }

      this.$emit('onSubmit', this.form)
    },
    setDefaultValues() {
      this.form.jv_type = this.journalEntry.jv_type
      this.form.description = this.journalEntry.description
      this.form.lines = this.journalEntry.lines.map((line) => {
        const accountType = line.account_type
        const accountCode = line.account_code
        const accountName = getMasterDataText(line.account_name, this.$t)
        return {
          query: `${accountCode} - ${accountName}`,
          account_type: accountType,
          account_code: accountCode,
          debit: this.setToCustomDigitsNumber(line.debit),
          credit: this.setToCustomDigitsNumber(line.credit),
          label: line.label,
        }
      })
    },
  },

  created() {
    if (this.journalEntry) {
      this.setDefaultValues()
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/combine/JournalEntryForm.vue